import request from '@/utils/request'
// 生成时间:2022-04-12 09:35:42

// 查询table列表
export function listTable(query) {
    var data={
        filterstr:"",
        orderby:"",
        opstr:query.opstr ||{},
        page_size:query.pageSize,
        page:query.pageNum
    };
    var filterstr={};
    for(var k in query){
     var item=query[k];
     if(k!="pageSize" && k!="pageNum"&&k!="opstr"){
       filterstr[k]=item;
     }
    }
    data["filterstr"] = JSON.stringify(filterstr);
    data["opstr"] = JSON.stringify(data["opstr"]);
    return request({
        url: '/bpm/table/list',
        method: 'post',
        data: data
    })
}

// 查询table详细
export function getTable (id) {
    return request({
        url: '/bpm/table/get?id='+id,
        method: 'get'
    })
}


// 新增table
export function addTable(data) {
    return request({
        url: '/bpm/table/add',
        method: 'post',
        data: data
    })
}

// 修改table
export function editTable(data) {
    return request({
        url: '/bpm/table/edit',
        method: 'post',
        data: data
    })
}

// 删除table
export function delTable(ids) {
    return request({
        url: '/bpm/table/del',
        method: 'post',
        data:{ids:ids}
    })
}

// 删除table查询模板
export function advquerydelTable(ids) {
    return request({
        url: '/bpm/table/advquerydel',
        method: 'post',
        data:{ids:ids}
    })
}

// 添加table查询模板
export function advquerysaveTable(data) {
    return request({
        url: '/bpm/table/advquerysave',
        method: 'post',
        data: data
    })
}
// 列表table查询模板列表
export function advquerylistTable(businessname) {
    return request({
        url: '/bpm/table/advquerylist?businessname='+businessname,
        method: 'get'
    })
}
// 导出table
export function exportTable(query,exportfields,tableColumn) {
     var data={
            filterstr:"",
            orderby:"",
            opstr:query.opstr ||{},
        };
        var filterstr={};
        for(var k in query){
         var item=query[k];
         if(k!="pageSize" && k!="pageNum"&&k!="opstr"){
           filterstr[k]=item;
         }
        }
        var tarexportfieldslist={};
        for(var k in tableColumn){
          var tlbf = tableColumn[k];
           for(var i in exportfields){
             var ef = exportfields[i]
             if(tlbf.field!="" && tlbf.field && tlbf.field!=null && tlbf.field == ef){
               tarexportfieldslist.push({"filed":ef,"title":tlbf.title});
               break;
             }
           }
        }

        data["filterstr"] = JSON.stringify(filterstr);
        data["opstr"] = JSON.stringify(data["opstr"]);
        data["exportfields"] = JSON.stringify(tarexportfieldslist);
        return request({
            url: '/bpm/table/export',
            method: 'post',
            data: data
        })
}

// 查询db数据库列表
export function listDbTable(query) {
  return request({
    url: '/bpm/table/dbtablelist',
    method: 'get',
    params: query
  })
}
// 导入表
export function importTable(data) {
  return request({
    url: '/bpm/table/import_table_save',
    method: 'post',
    params: data
  })
}
